export const statesAndProvinces = [
  {
    text: "CANADIAN PROVINCES",
    items: [
      { id: "AB", value: "AB", text: "Alberta" },
      { id: "BC", value: "BC", text: "British Columbia" },
      { id: "MB", value: "MB", text: "Manitoba" },
      { id: "NB", value: "NB", text: "New Brunswick" },
      { id: "NL", value: "NL", text: "Nfld./Labrador" },
      { id: "NT", value: "NT", text: "Northwest Territories" },
      { id: "NS", value: "NS", text: "Nova Scotia" },
      { id: "NU", value: "NU", text: "Nunavut" },
      { id: "ON", value: "ON", text: "Ontario" },
      { id: "PE", value: "PE", text: "Prince Edward Island" },
      { id: "QC", value: "QC", text: "Quebec" },
      { id: "SK", value: "SK", text: "Saskatchewan" },
      { id: "YT", value: "YT", text: "Yukon" },
    ],
  },
  {
    text: "AMERICAN STATES",
    items: [
      { id: "AL", value: "AL", text: "Alabama" },
      { id: "AK", value: "AK", text: "Alaska" },
      { id: "AZ", value: "AZ", text: "Arizona" },
      { id: "AR", value: "AR", text: "Arkansas" },
      { id: "CA", value: "CA", text: "California" },
      { id: "CO", value: "CO", text: "Colorado" },
      { id: "CT", value: "CT", text: "Connecticut" },
      { id: "DE", value: "DE", text: "Delaware" },
      { id: "FL", value: "FL", text: "Florida" },
      { id: "GA", value: "GA", text: "Georgia" },
      { id: "HI", value: "HI", text: "Hawaii" },
      { id: "ID", value: "ID", text: "Idaho" },
      { id: "IL", value: "IL", text: "Illinois" },
      { id: "IN", value: "IN", text: "Indiana" },
      { id: "IA", value: "IA", text: "Iowa" },
      { id: "KS", value: "KS", text: "Kansas" },
      { id: "KY", value: "KY", text: "Kentucky" },
      { id: "LA", value: "LA", text: "Louisiana" },
      { id: "ME", value: "ME", text: "Maine" },
      { id: "MD", value: "MD", text: "Maryland" },
      { id: "MA", value: "MA", text: "Massachusetts" },
      { id: "MI", value: "MI", text: "Michigan" },
      { id: "MN", value: "MN", text: "Minnesota" },
      { id: "MS", value: "MS", text: "Mississippi" },
      { id: "MO", value: "MO", text: "Missouri" },
      { id: "MT", value: "MT", text: "Montana" },
      { id: "NE", value: "NE", text: "Nebraska" },
      { id: "NV", value: "NV", text: "Nevada" },
      { id: "NH", value: "NH", text: "New Hampshire" },
      { id: "NJ", value: "NJ", text: "New Jersey" },
      { id: "NM", value: "NM", text: "New Mexico" },
      { id: "NY", value: "NY", text: "New York" },
      { id: "NC", value: "NC", text: "North Carolina" },
      { id: "ND", value: "ND", text: "North Dakota" },
      { id: "OH", value: "OH", text: "Ohio" },
      { id: "OK", value: "OK", text: "Oklahoma" },
      { id: "OR", value: "OR", text: "Oregon" },
      { id: "PA", value: "PA", text: "Pennsylvania" },
      { id: "RI", value: "RI", text: "Rhode Island" },
      { id: "SC", value: "SC", text: "South Carolina" },
      { id: "SD", value: "SD", text: "South Dakota" },
      { id: "TN", value: "TN", text: "Tennessee" },
      { id: "TX", value: "TX", text: "Texas" },
      { id: "UT", value: "UT", text: "Utah" },
      { id: "VT", value: "VT", text: "Vermont" },
      { id: "VA", value: "VA", text: "Virginia" },
      { id: "WA", value: "WA", text: "Washington" },
      { id: "WV", value: "WV", text: "West Virginia" },
      { id: "WI", value: "WI", text: "Wisconsin" },
      { id: "WY", value: "WY", text: "Wyoming" },
      { id: "AS", value: "AS", text: "American Samoa" },
      { id: "DC", value: "DC", text: "District of Columbia" },
      { id: "FM", value: "FM", text: "Federated States of Micronesia" },
      { id: "GU", value: "GU", text: "Guam" },
      { id: "MH", value: "MH", text: "Marshall Islands" },
      { id: "MP", value: "MP", text: "Northern Mariana Islands" },
      { id: "PW", value: "PW", text: "Palau" },
      { id: "PR", value: "PR", text: "Puerto Rico" },
      { id: "VI", value: "VI", text: "Virgin Islands" },
      { id: "AE1", value: "AE", text: "Armed Forces Abroad" },
      { id: "AA", value: "AA", text: "Armed Forces Americas" },
      { id: "AE2", value: "AE", text: "Armed Forces Canada" },
      { id: "AE3", value: "AE", text: "Armed Forces Europe" },
      { id: "AE4", value: "AE", text: "Armed Forces Middle East" },
      { id: "AP", value: "AP", text: "Armed Forces Pacific" },
    ],
  },
  {
    text: "Outside of Canada & US",
    items: [{ id: "ZZ", value: "ZZ", text: "Other" }],
  },
];

export const donationRegions = [
  { value: "NB", text: "New Brunswick" },
  { value: "PE", text: "Prince Edward Island" },
  { value: "CB", text: "Cape Breton" },
  { value: "NS", text: "Mainland Nova Scotia" },
];

export const months = [
  { value: "01", text: "January" },
  { value: "02", text: "February" },
  { value: "03", text: "March" },
  { value: "04", text: "April" },
  { value: "05", text: "May" },
  { value: "06", text: "June" },
  { value: "07", text: "July" },
  { value: "08", text: "August" },
  { value: "09", text: "September" },
  { value: "10", text: "October" },
  { value: "11", text: "November" },
  { value: "12", text: "December" },
];

export const getCountryCode = (provState) => {
  if ((provState || "").length === 0) {
    return "US";
  }

  if ("AB|BC|MB|NB|NL|NT|NS|NU|ON|PE|QC|SK|YT".indexOf(provState) >= 0) {
    return "CA";
  }

  return "US";
}

export const getYears = () => {
  let currentYear = new Date().getFullYear();
  const yearList = [];

  for (let i = 0; i < 10; i++) {
    const twoDigitYear = currentYear % 100;
    const fourDigitYear = currentYear.toString();

    yearList.push({ value: twoDigitYear, text: fourDigitYear });

    currentYear++;
  }

  return yearList;
}